module.exports = __webpack_public_path__ + "static/media/Korean-numbers.ea8e9173.jpg";